export const AppConfig = {
  tabQueue: false,
};
